export const QUERY_FETCH_NOTES = 'notes-stream-load';
